var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 center-text"},[_c('div',{staticClass:"loading-block"},[_c('rotate-square4',{attrs:{"size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }